var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.78125 2.3125L10.625 6.15625C10.8438 6.375 11 6.6875 11 7C11 7.34375 10.8438 7.65625 10.625 7.875L6.78125 11.7188C6.59375 11.9062 6.3125 12 6.03125 12C5.46875 12 5 11.5312 5 10.9688V9H1C0.4375 9 0 8.5625 0 8V6C0 5.46875 0.4375 5 1 5H5V3.0625C5 2.5 5.46875 2 6.03125 2C6.3125 2 6.59375 2.125 6.78125 2.3125ZM11 12H13C13.5312 12 14 11.5625 14 11V3C14 2.46875 13.5312 2 13 2H11C10.4375 2 10 1.5625 10 1C10 0.46875 10.4375 0 11 0H13C14.6562 0 16 1.34375 16 3V11C16 12.6562 14.6562 14 13 14H11C10.4375 14 10 13.5625 10 13C10 12.4688 10.4375 12 11 12Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLogout);
export default __webpack_public_path__ + "static/media/icon-logout.c2a033d8653d1502f874b81ed147d2f8.svg";
export { ForwardRef as ReactComponent };